module.exports = __webpack_public_path__ + "static/media/customer-bikanerwala.84f5e5b6.png";